import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { API } from 'aws-amplify'
import StoryTitle from '../components/StoryTitle'
import StoryTable from '../components/StoryTable'
import color from '../shared/color'
import { ChoroplethUS, DonutChart, ScatterPlot, StackBarChart } from '../d3'
import { Typography, Grid, CircularProgress, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import '../story.css'

function DevOpsKPI() {

  const [title] = useState("DevOps Key Performance Indicators")
  const [summary] = useState("Key Performance Indicators of Software deployment and development in BD MMS.")
  const [categories] = useState(['implementation', 'performance', 'security'])
  const [isLoading, setIsLoading] = useState(true)
  const [data, setData] = useState(null)
  const [filterLayout] = useState([
    { column: 'Column', field: 'column_name' },
    { column: 'Filter Value', field: 'value_name' },
    { column: 'Product Type', field: 'producttype' },
  ])
  const [revLayout] = useState([
    { column: 'Grouping Value', field: 'grouping' },
    { column: 'Result', field: 'value_name' },
  ])
  const [tfsLayout] = useState([
    { column: 'Established TFS Value', field: 'tfsValue' },
  ])


  const [bubbleColor, setBubColor] = useState(null)
  const useStyles = makeStyles({
    table: {
      minWidth: 650,
    },
  })

    let history = useHistory()

    useEffect(() => {
        setBubColor(new Map([
            ["Scheduled_with_permission", "#4e79a7"],
            ["Customer_Managed", "#f28e2c"],
            ["Scheduled_wo_permission", "#59a14f"]
          ]))
        async function fetch() {
            await API.get('qs-web-api', '/data/DevopsKPI/DevopsKPI.json', {})
                .then((storyData) => {
                    setData(storyData)
                })
                .catch(function (error) {
                    console.log(error)
                })
            setIsLoading(false)
        }
        fetch()
    }, [])

    if (isLoading) {
        return (<div className="circular-progress"><CircularProgress disableShrink /></div>)
    } else {
        return (
            <div id="story">
                <StoryTitle title={title} date={data.date} categories={categories}></StoryTitle>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch" >
                        <div className="subText">
                        <Typography >
                        <p>
                        Measuring the success of an organizations DevOps practices are largely dependent on the ability to track and quantify proper key performance indicators (KPIs) and other metrics that help evaluate success and identify areas of improvement.
                         </p>
                        <p>
                        This article servers as a main page between Change Volume, Deployment Time, Failed Deployments, Lead Time and Mean Time. Others that will be added as Application Usage and Traffic, Error Rates, Application Performance, Automated Testing and Defect Escape Rates.
                        </p>
                        <p>
                        Currently MMS DataOps is measuring Github, Jenkins, Artifactory , Device Insights ,SonarCloud, Microsoft Team Foundation Server (TFS), Software Engineering and Test (SWET) and AWS Systems Manager (SSM) to establish a baseline to evaluate trends.
                        </p>
                        <p>
                        This article is the rollup of metrics, for a deeper dive please visit - <a href="https://bdlytics.stage.bdservices.io/dashboard/DevOpsKPI">Devops KPI</a> and for a summary of TFS and data dictionary <a href="https://bdlytics.stage.bdservices.io/tfscurrentstate">TFS Current State</a>.
                        </p>
                        </Typography>
                        </div>
                    </Grid>
                </Paper>
                <Paper className="storySection">
                    <Grid container justify="left" spacing={2} alignItems="stretch" >
                        <div className="subText">
                        <Typography >
                        <p>
                        <a href="/DevOpsKPI_ChangeVolume">Change Volume</a>
                         </p>
                        <p>
                        Change Volume goes hand-in-hand with deployment frequency, and quantifies the number of new user stories or code changes the DevOps team delivers with each release, or in a given period of time.
                         </p>

                        </Typography>
                        </div>
                    </Grid>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="left" spacing={2} alignItems="stretch" >
                        <div className="subText">
                        <Typography >
                        <p>
                        <a href="/DevOpsKPI_FailedDeployments">Failed Deployments</a>
                         </p>
                        <p>
                        Failed deployments metric is tracked over time to create a correlation between time, root failure cause and impact to the deployment. This metric is measured per release and during specific time periods.
                        </p>


                        </Typography>
                        </div>
                    </Grid>
                </Paper>
                <Paper className="storySection">
                    <Grid container justify="left" spacing={2} alignItems="stretch" >
                        <div className="subText">
                        <Typography >
                        <p>
                        <a href="/DevOpsKPI_MeanTime">Mean Time to Recovery (MTTR)</a>
                         </p>
                        <p>
                        MTTR is a key performance indicator that gauges your company''s efficiency in resolving issues. The ability to evaluate the business impact and customer experience repercussion provides insight needed to fully understand and prioritize problems. MTTR measures average recovery time from failure to resolution, and provides answers about whether customers lost access, experienced errors, or abandoned the application. Improving MTTR reduces impact of said problems, costs and protects customer satisfaction.
                        </p>
                        </Typography>
                        </div>
                    </Grid>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="left" spacing={2} alignItems="stretch" >
                        <div className="subText">
                        <Typography >
                        <p>
                        <a href="/DevOpsKPI_LeadTime">Lead Time</a>
                         </p>
                        <p>
                        Lead time measures the total time it takes for work to move through the value stream, from the moment the work is requested to the time it is delivered.
                         </p>


                        </Typography>
                        </div>
                    </Grid>
                </Paper>

                    <Paper className="storySection">
                    <Grid container justify="left" spacing={2} alignItems="stretch" >
                        <div className="subText">
                        <Typography >
                        <p>
                        <a href="https://bdlytics.stage.bdservices.io/dashboard/DevOpsKPI">Sonar Cloud</a>
                         </p>
                        <p>
                        For SonarCloud data, please us the Quicksight SonarCloud tab as it will direct to the issue.
                        </p>

                        </Typography>
                        </div>
                    </Grid>
                    </Paper>
                    <Paper className="storySection">
                    <Grid container justify="left" spacing={2} alignItems="stretch" >
                        <div className="subText">
                        <Typography >
                        <p>
                        <a href="/TfsCurrentState">TFS Current State</a>
                         </p>
                        <p>
                        Microsoft Team Foundation Server (TFS) is software that helps teams manage code and develop projects.
                        </p>

                        </Typography>
                        </div>
                    </Grid>
                    </Paper>
                    <Paper className="storySection">
                    <Grid container justify="left" spacing={2} alignItems="stretch" >
                        <div className="subText">
                        <Typography >
                        <p>
                        <a href="https://bdlytics.stage.bdservices.io/dashboard/Machine_Performance_Assessment_Report">Machine Performance Assessment Report</a>
                         </p>
                        <p>
                        Machine Performance Assessment Report (MPAR) which is the in field hardware reporting.
                        </p>
                        </Typography>
                        </div>
                    </Grid>
                    </Paper>
                    <Paper className="storySection">
                    <Grid container justify="left" spacing={2} alignItems="stretch" >
                        <div className="subText">
                        <Typography >
                        <p>
                         <a href="https://bddevops.atlassian.net/wiki/spaces/DEVOPS/pages/172359740/DevOps+KPI">Status Planned Metric Development</a>
                         </p>
                        <p>
                        Cross-functional development for MMS R&D to best understand DevOps Key Performance indicators. Please add comments and questions.
                        </p>
                        </Typography>
                        </div>
                    </Grid>
                </Paper>

            </div >

    )
  }
}

export default DevOpsKPI